import React from "react";
import RegistryPage from "../components/RegistryPage";
import { StatusBadge } from "../components/Badges";

const LAWFUL = ["consent","legitimate_use","legal_compliance","employment","medical_emergency","public_interest","state","other"];

export default function ProcessingActivities() {
  return (
    <RegistryPage
      title="Processing Activity Registry"
      description="DPDP-adapted Record of Processing Activities (RoPA)."
      endpoint="/processing-activities"
      testIdPrefix="activities"
      reportKey="activities"
      columns={[
        { key: "name", label: "Activity" },
        { key: "lawful_basis", label: "Lawful basis", width: "140px" },
        { key: "consent_required", label: "Consent", width: "90px" },
        { key: "cross_border_flag", label: "Cross-border", width: "110px" },
        { key: "dpia_required", label: "DPIA", width: "80px" },
        { key: "status", label: "Status", width: "110px", render: (i) => <StatusBadge status={i.status} /> },
      ]}
      fields={[
        { key: "name", label: "Activity name", required: true },
        { key: "description", label: "Description", type: "textarea", full: true },
        { key: "business_unit", label: "Business unit" },
        { key: "lawful_basis", label: "Lawful basis", type: "select", options: LAWFUL },
        { key: "consent_required", label: "Consent required", type: "checkbox" },
        { key: "data_categories", label: "Data categories (comma)" },
        { key: "principal_categories", label: "Principal categories (comma)" },
        { key: "collection_source", label: "Collection source" },
        { key: "recipients", label: "Recipients (comma)" },
        { key: "processors", label: "Processors (comma)" },
        { key: "retention_period_days", label: "Retention (days)", type: "number" },
        { key: "deletion_trigger", label: "Deletion trigger", type: "select", options: ["purpose_completion","consent_withdrawal","inactivity","statutory"] },
        { key: "cross_border_flag", label: "Cross-border transfer", type: "checkbox" },
        { key: "child_data_flag", label: "Involves children", type: "checkbox" },
        { key: "automated_decisioning_flag", label: "Automated decisioning", type: "checkbox" },
        { key: "risk_score", label: "Risk score (0-100)", type: "number" },
        { key: "dpia_required", label: "DPIA required", type: "checkbox" },
        { key: "status", label: "Status", type: "select", options: ["draft","under_review","approved","active","retired"] },
      ]}
      defaultItem={{ name: "", lawful_basis: "consent", consent_required: true, data_categories: [], principal_categories: [], recipients: [], processors: [], status: "draft", risk_score: 0, cross_border_flag: false, child_data_flag: false, automated_decisioning_flag: false, dpia_required: false }}
    />
  );
}
